import { render, staticRenderFns } from "./ClientSacker.vue?vue&type=template&id=58873060"
import script from "./ClientSacker.vue?vue&type=script&lang=js"
export * from "./ClientSacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports